import React from 'react'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import SimpleReactLightbox from 'simple-react-lightbox'

import { Router } from './components/Router'
import { ToastContainer } from './lib/feedbotToast'
import { loadFontAwesome } from './AppService/AppService'
import { ErrorBoundary } from './components/errors'
import { FeedbotThemeProvider } from './components/theme'
import SelectPortalProvider from './components/SelectPortalProvider'
import { useSentryIntegration } from './features/sentry'
import './styleOverrides.scss'
import './rjsfStyles.scss'
import { StatsigProvider } from './features/statsig'
import { DevTools } from './features/devTools'
import { FeedbotHelmet } from './components/FeedbotHelmet'
import { endpointHelpers } from './features/serverBots/endpointHelpers'
import { Modals } from './components/modals/Modals'
import { GlobalSuspenseDecorator } from './components/GlobalSuspenseDecorator'
import { useSocketServerConnection } from './store/socketServer/hooks/useSocketServerConnection'
import { PerfoMonitorFeatureGate } from './lib/performance/usePerfoMonitor'

loadFontAwesome()

const AppComponent: React.FC = () => {
  useSocketServerConnection() // Keep this as high as possible to connect asap

  //  Prefetch - not sure if this results in earlier triggers, but it surely doesn't hurt :)
  endpointHelpers.getCurrentUserPermissionsForCurrentBot.useQuery()
  endpointHelpers.getConfigurationForCurrentBot.useQuery()
  endpointHelpers.getOriginalVersionFlowForCurrentBot.useQuery()
  endpointHelpers.getBotsMetadata.useQuery()

  useSentryIntegration()

  return (
    <GlobalSuspenseDecorator>
      <StatsigProvider>
        <SimpleReactLightbox>
          <FeedbotThemeProvider>
            <SelectPortalProvider>
              <ErrorBoundary>
                <Modals />
                <FeedbotHelmet />
                <Router />
                <ToastContainer />
                <DevTools />
                <PerfoMonitorFeatureGate />
              </ErrorBoundary>
            </SelectPortalProvider>
          </FeedbotThemeProvider>
        </SimpleReactLightbox>
      </StatsigProvider>
    </GlobalSuspenseDecorator>
  )
}

export const App = DragDropContext(HTML5Backend)(AppComponent)
